export type Site = {
  id: string;
  displayName: string;
  webUrl: string;
  name: string;
};

export type Drive = {
  id: string;
  name: string;
  description: string;
  webUrl: string;
  driveType: string;
};

export interface SharePointState {
  settings: any | null;
  sites: Site[];
  drives: Drive[];
  selectedSite: Site | null;
  selectedDrive: Drive | null;
  folderPath: string;
  grantResult: any | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

export const initialState: SharePointState = {
  settings: null,
  sites: [],
  drives: [],
  selectedSite: null,
  selectedDrive: null,
  folderPath: '',
  grantResult: null,
  loading: false,
  saving: false,
  error: null,
};
